require('./bundle-manifest').register(JSON.parse("{\"HEJqs\":\"index.803515b5.js\",\"yMIUE\":\"city.d280d2e0.webp\"}"));